/**
 * Paliers d'achat intégré des SKILLCARDS (Google Play / App Store) — migration 0351.
 *
 * Un store n'accepte que des produits au prix FIGÉ : on ne crée donc PAS un
 * produit par carte / pack / programme, mais une grille de produits
 * consommables « palier » (`jr_sk_0199` = 1,99 €…). Le serveur calcule le prix
 * exact (`skillcard_quote`, déductions et remises comprises) puis prend le
 * palier le plus PROCHE ; l'achat du palier est rattaché à la commande par le
 * webhook RevenueCat.
 *
 * ⚠️ Miroir SQL : table `skillcard_iap_tiers` (même liste) — parité testée.
 */

/** Prix TTC en centimes d'euro, croissants. */
export const SKILLCARD_IAP_TIER_CENTS = [
  199, 299, 399, 499, 599, 699, 799, 899, 999, 1199, 1399, 1599, 1799, 1999, 2299, 2499, 2999, 3499,
  3999, 4499, 4999, 5499, 5999, 6999, 7999, 8999,
] as const;

/** Identifiant de produit store d'un palier : `jr_sk_0199`. */
export function skillcardIapProductId(cents: number): string {
  return `jr_sk_${String(cents).padStart(4, '0')}`;
}

/** Palier d'un identifiant de produit (`jr_sk_0199` → 199), sinon null. */
export function skillcardIapTierFromProductId(productId: string): number | null {
  const m = /^jr_sk_(\d{4})$/.exec(productId);
  if (!m) return null;
  const cents = Number(m[1]);
  return (SKILLCARD_IAP_TIER_CENTS as readonly number[]).includes(cents) ? cents : null;
}

/**
 * Palier le plus proche d'un prix (à égalité, le palier supérieur) ; null si
 * le prix dépasse le dernier palier de plus de 10 % (achat sur le site).
 */
export function skillcardIapTierFor(priceCents: number): number | null {
  if (!Number.isFinite(priceCents) || priceCents <= 0) return null;
  const tiers = SKILLCARD_IAP_TIER_CENTS as readonly number[];
  const last = tiers[tiers.length - 1]!;
  if (priceCents > last * 1.1) return null;
  let best = tiers[0]!;
  for (const t of tiers) {
    if (
      Math.abs(t - priceCents) < Math.abs(best - priceCents) ||
      (Math.abs(t - priceCents) === Math.abs(best - priceCents) && t > best)
    ) {
      best = t;
    }
  }
  return best;
}
